import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CloudBlank02 = function CloudBlank02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9.5 19C5.3579 19 2 15.6421 2 11.5S5.3579 4 9.5 4c2.8827 0 5.3855 1.6263 6.641 4.0115A5.6 5.6 0 0 1 16.5 8c3.0376 0 5.5 2.4624 5.5 5.5S19.5376 19 16.5 19z"
    })
  }));
};
export default CloudBlank02;